import { create } from 'zustand';

interface ManageDeleteObjModalV2State {
  isOpen: boolean;
  id?: number;
  title?: string;
  objectName?: string;
  onManageObjectDeleteModalV2Close: () => void;
  onManageObjectDeleteModalV2Open: (id: number, title: string, objectName: string) => void;
}

export const useManageDeleteObjModalV2Store = create<ManageDeleteObjModalV2State>(set => ({
  isOpen: false,
  id: undefined,
  title: undefined,
  objectName: undefined,
  onManageObjectDeleteModalV2Close: () =>
    set({ isOpen: false, id: undefined, title: undefined, objectName: undefined }),
  onManageObjectDeleteModalV2Open: (id: number, title: string, objectName: string) =>
    set({ isOpen: true, id, title, objectName }),
}));
